import React, { Component } from "react";
import "./App.css";
import { EmojiListArray } from "./App.js";

class EmojiApp extends Component {
  state = {
    Data: EmojiListArray,
    Name: "",
  };

  HandleChange = (e) => {
    this.setState({
      Name: e.target.value,
    });
  };

  render() {
    let filteredData = this.state.Data.filter((obj) => {
      return obj.title.includes(this.state.Name);
    });
    let response = filteredData.map((obj, index) => {
      return (
        <li key={index}>
          <span>{obj.symbol}</span>
          <p>{obj.title}</p>
        </li>
      );
    });
    return (
      <div className="EmojiApp">
        <h1>Filter Emoji</h1>
        <input
          type="text"
          placeholder="Search Emoji by name"
          onChange={this.HandleChange}
        />
        <ul>{response}</ul>
      </div>
    );
  }
}

export default EmojiApp;
